document.querySelectorAll('.countdown_time--container').forEach(container => {
  const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;
  
  let timer = container.getAttribute('data-timer-date'),
      countDown = new Date(timer).getTime();

  if (isNaN(countDown)) {
    console.error('Invalid timer date:', timer);
    return; // Skip if the date is invalid
  }

  const countdownWrapper = container.querySelector('.countdown_timer--item--countdown');
  const headlineElem = container.querySelector('.timer-headline');

  const updateTimer = () => {
    let now = new Date().getTime(),
        distance = countDown - now;
    
    container.querySelector('.days').textContent = Math.floor(distance / day);
    container.querySelector('.hours').textContent = Math.floor((distance % day) / hour);
    container.querySelector('.minutes').textContent = Math.floor((distance % hour) / minute);
    container.querySelector('.seconds').textContent = Math.floor((distance % minute) / second);
    
    if (distance < 0) {
      const titleAfterExpire = container.getAttribute('data-timer-title');

      if (headlineElem) {
        headlineElem.classList.add('time_expired');
        headlineElem.textContent = titleAfterExpire;
      }
      
      if (countdownWrapper) {
        countdownWrapper.remove(); // Remove the entire countdown wrapper when time expires
      }

      clearInterval(interval);
    }
  };

  const interval = setInterval(updateTimer, 1000);
  updateTimer(); // Initial call to update immediately
});
